<template>
    <div class="container body fix-footer">
        <div class="row justify-content-center">
            <div class="col-md-8 mt-5 mb-3">
                <div class="card">
                    <div class="card-header">
                        <h3>{{$t('pages.NewSliderImage')}}</h3>
                    </div>
                    <div class="card-body">
                        <div class="alert alert-danger" v-if="error">
                            {{$t(error)}}
                        </div>
                        <form @submit="submit">
                            <formly-form :form="form" :model="model" :fields="fields" ref="createImage"/>
                            <button type="submit" class="btn btn-primary">{{ $t('button.Save') }}</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import { mapActions } from 'vuex';
  import isLength from 'validator/lib/isLength';
  import { ROUTER_NAMES, ERROR_MESSAGES } from '../../constants';

  export default {
    name: 'CreateSliderImage',
    data() {
      return {
        error: '',
        form: {},
        model: {
          title: '',
          text: '',
          order: 1,
          active: true,
        },
        fields: [
          {
            key: 'image',
            type: 'image',
            templateOptions: {
              label: this.$t('fields.Image')
            },
            required: true
          },
          {
            key: 'title',
            type: 'input',
            templateOptions: {
              label: this.$t('fields.Title')
            },
            required: true,
            validators: {
              validTitle: {
                expression(field, model, next) {
                  next(isLength(model[field.key], { min: 3 }));
                },
                message: 'Nazov musi obsahovat aspoň 3 znaky'
              }
            }
          },
          {
            key: 'text',
            type: 'mce',
            templateOptions: {
              label: this.$t('fields.Text'),
            },
            required: true,
            validators: {
              validShort: {
                expression(field, model, next) {
                  next(isLength(model[field.key], {
                    min: 10
                  }));
                },
                message: this.$tc('validation.min', 10)
              }
            }
          },
          {
            key: 'order',
            type: 'input',
            templateOptions: {
              label: this.$t('fields.Order'),
              inputType: 'number'
            },
            required: true,
          },
        ]
      };
    },
    methods: {
      ...mapActions(['createImage']),
      submit(e) {
        e.preventDefault();

        this.$refs.createImage.validate()
          .then(() => {
            if (!this.form.$valid) return;

            this.createImage(this.model)
              .then(() => {
                this.$router.push({
                  name: ROUTER_NAMES.SLIDER_IMAGES
                });
              })
              .catch(() => {
                this.error = ERROR_MESSAGES.INTERNAL_SERVER_ERROR;
              });
          });
      }
    }
  };
</script>

<style scoped>

</style>
